import { Plus, Download } from "lucide-react";

export default function ComprasHeader({ title, subtitle, handleAdd, handleDescargarXlsx, loadingXlsx }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6 gap-4">
      <div>
        <h1 className="text-2xl font-bold text-gray-800 mb-1">{title}</h1>
      </div>

      <div className="flex items-center gap-3">
        <button
          className="inline-flex items-center justify-center gap-2 rounded-lg bg-emerald-600 px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-emerald-700 disabled:cursor-not-allowed disabled:opacity-50"
          onClick={handleDescargarXlsx}
          disabled={loadingXlsx}
        >
          <Download className="w-4 h-4" />
          {loadingXlsx ? "Generando..." : "Descargar XLSX"}
        </button>

        <button
          className="flex items-center gap-2 bg-[#104063] hover:bg-[#0d3553] text-white px-4 py-2 rounded-lg font-medium transition-colors shadow-sm cursor-pointer"
          onClick={handleAdd}
        >
          <Plus className="w-4 h-4" />
          Nueva Compra
        </button>
      </div>
    </div>
  );
}
